import React, { useState, useEffect } from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import AppLayout from "./AppLayout";
import ProductTable from "./ProductTable";
import ProductForm from "./ProductForm";
import ProductDetails from "./ProductDetails";
import ProductEdit from "./ProductEdit";
import Dashboard from "./Dashboard";
import Login from "./Login";
import AdminUsers from "./AdminUsers";
import UserProfile from "./UserProfile";
import Reports from "./Reports";

const App = () => {
  const [user, setUser] = useState(null);
  const [username, setUsername] = useState(null);
  const [loading, setLoading] = useState(true);

  // Załaduj dane użytkownika po starcie
  useEffect(() => {
    const storedUser = localStorage.getItem("user");
    const storedUsername = localStorage.getItem("username");

    if (storedUser && storedUsername) {
      setUser(JSON.parse(storedUser));
      setUsername(storedUsername);
    }
    setLoading(false);
  }, []);

  const handleLogin = (name) => {
    const userData = localStorage.getItem("user");
    setUsername(name);
    if (userData) setUser(JSON.parse(userData));
  };

  const handleLogout = () => {
    localStorage.removeItem("auth_token");
    localStorage.removeItem("username");
    localStorage.removeItem("user");
    setUsername(null);
    setUser(null);
    window.location.href = "/login";
  };

  if (loading) return null; // nie renderuj nic dopóki nie sprawdzimy localStorage

  return (
    <BrowserRouter>
      <Routes>
        {/* Login zawsze dostępny */}
        <Route path="/login" element={<Login onLogin={handleLogin} />} />

        {username ? (
          <Route path="/" element={<AppLayout username={username} onLogout={handleLogout} />}>
            <Route index element={<Dashboard />} />
            <Route path="products" element={<ProductTable />} />
            <Route path="products/add" element={<ProductForm />} />
            <Route path="products/:id" element={<ProductDetails />} />
            <Route path="products/:id/edit" element={<ProductEdit />} />
            <Route path="profile" element={<UserProfile />} />
            <Route path="reports" element={<Reports />} />
            <Route
              path="admin/users"
              element={user?.role === "admin" ? <AdminUsers /> : <Navigate to="/" />}
            />
          </Route>
        ) : (
          <Route path="*" element={<Navigate to="/login" replace />} />
        )}
      </Routes>
    </BrowserRouter>
  );
};

export default App;
